import { useRef, useState, useEffect, memo, Fragment } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({
  id,
  children
}) => {
  if (typeof window !== 'object') {
    return Fragment;
  } // get element already in DOM or create another with the id


  const node = useRef(document.getElementById(id) || document.createElement('div'));
  const [dynamic] = useState(!node.current.parentElement);
  useEffect(() => {
    if (dynamic) {
      node.current.id = id;
      if (document.querySelector('main')) document.querySelector('main').appendChild(node.current);else document.body.appendChild(node.current);
    }

    return () => {
      if (dynamic && node.current.parentElement) {
        node.current.parentElement.removeChild(node.current);
      }
    };
  }, [id]);
  return /*#__PURE__*/createPortal(children, node.current);
};

export default /*#__PURE__*/memo(Portal);